import { useEffect, useState } from "react";

import Button from "@material-ui/core/Button";
import {
  orderConnector,
  withBonusFiltered,
} from "../../../services/orders/bonus.connector";
import { compose } from "redux";
import { TextField } from "@material-ui/core";
import CurrencyFormater from "../../../shared/ui/Currency.Input";
import TableNew, { CELL_TYPES } from "../../../shared/Table";
import { TableCellAccountRedirect } from "../../../shared/Table/components/Cell";
import MenuItem from "@material-ui/core/MenuItem";
import ClaimsWrapper from "../../../shared/ui/Claim.Wrapper";
import { allClaimsOtherThanAml } from "../../../shared/ClaimLists/Claim.Aml.All.List";

const BonusTableActions = ({ confirmBonusPayment, cancelBonusOrder, item }) => {
  return (
    <div className="table-cell-actions">
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          confirmBonusPayment(item.Id);
        }}
      >
        Confirm
      </Button>
      <br />
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          cancelBonusOrder(item.Id);
        }}
      >
        Cancel
      </Button>
    </div>
  );
};

const BonusRegistrationComponent = ({
  registerBonusPayments,
  fetchCreatedBonusPayments,
  confirmBonusPayment,
  cancelBonusOrder,
  orders,
  accountId,
  currentUser,
}) => {
  const fromProfile = !!accountId;

  const [depotId, setDepotId] = useState("");
  const [amount, setAmount] = useState("");
  const columns = [
    {
      key: "InvestorId",
      label: "Investor Id",
      visible: true,
      type: CELL_TYPES.text,
      renderer: (value) => {
        return <TableCellAccountRedirect value={value} type={"accountId"} />;
      },
    },
    { key: "Id", label: "Id", visible: true, type: CELL_TYPES.text },
    {
      key: "InvestorName",
      label: "Investor Name",
      visible: true,
      type: CELL_TYPES.text,
    },
    { key: "RefCode", label: "Ref code", visible: true, type: CELL_TYPES.text },
    { key: "DepotId", label: "Depot Id", visible: true, type: CELL_TYPES.text },
    {
      key: "Amount.Amount",
      label: "Amount",
      visible: true,
      type: CELL_TYPES.money,
    },
    {
      key: "Currency",
      label: "Currency",
      visible: true,
      type: CELL_TYPES.text,
    },
    {
      key: "OrderDate",
      label: "Order date",
      visible: true,
      type: CELL_TYPES.date,
    },
    {
      key: "actions",
      label: "Actions",
      visible: true,
      renderer: (value, item) => {
        return (
          <BonusTableActions
            item={item}
            confirmBonusPayment={confirmBonusPayment}
            cancelBonusOrder={cancelBonusOrder}
          />
        );
      },
    },
  ];

  useEffect(() => {
    fetchCreatedBonusPayments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchCreatedBonusPayments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orders.bonus.sent]);

  return (
    <div className="deposit-layout body-height">
      {!fromProfile ? (
        <TextField
          size="small"
          variant="outlined"
          value={depotId}
          onChange={(event) => {
            setDepotId(event.target.value);
          }}
          label="DepotId"
        />
      ) : (
        <TextField
          label="Select depot id"
          menuItemStyle={{ color: "#000000" }}
          style={{ margin: "0 0 20px 0" }}
          select
          onChange={(event) => {
            setDepotId(event.target.value);
          }}
        >
          {currentUser.Depots.map((item, index) => {
            return (
              <MenuItem key={index} value={item}>
                {item}
              </MenuItem>
            );
          })}
        </TextField>
      )}
      <br />
      <CurrencyFormater
        label="Bonus amount"
        type="text"
        name="BonusAmount"
        value={amount}
        style={{ margin: "2px 10px 10px 0" }}
        onChange={(event) => {
          setAmount(event.target.value);
        }}
      />
      <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
        <Button
          variant="contained"
          color="primary"
          containerElement="label"
          onClick={() => {
            if (!!amount && !!depotId) registerBonusPayments(amount, depotId);
          }}
        >
          Register
        </Button>
      </ClaimsWrapper>
      <div>
        <br />
        <br />
        <TableNew
          columns={columns}
          items={orders.bonus.data}
          tableKey="bonusOrders"
          actionColumnWidth={180}
        />
      </div>
    </div>
  );
};

export default compose(
  orderConnector,
  withBonusFiltered,
)(BonusRegistrationComponent);
